hljs.registerLanguage("blade",(()=>{"use strict";return e=>({name:"Blade",
    case_insensitive:!0,subLanguage:"xml",contains:[e.COMMENT(/\{\{--/,/--\}\}/),{
        className:"template-variable",begin:/\{\{/,starts:{end:/\}\}/,returnEnd:!0,
            subLanguage:"php"}},{className:"template-variable",begin:/\}\}/},{
        className:"template-variable",begin:/\{!!/,starts:{end:/!!\}/,returnEnd:!0,
            subLanguage:"php"}},{className:"template-variable",begin:/!!\}/},{
        className:"template-tag",begin:/@php/,starts:{end:/@endphp/,returnEnd:!0,
            subLanguage:"php"},relevance:10},{begin:/@[\w]+/,end:/[\W]/,excludeEnd:!0,
        className:"template-tag"}]})})());
